import script from "./MDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./MDropdown.vue?vue&type=script&setup=true&lang=js"

import "./MDropdown.vue?vue&type=style&index=0&id=1358be4e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1358be4e"]])

export default __exports__